export const FISHINGREPORT_SECTION_MAX_CATCHES_MOBILE = 10;
export const FISHINGREPORT_SECTION_MAX_CATCHES_TABLET = 9;
export const FISHINGREPORT_SECTION_MAX_CATCHES_DESKTOP = 8;
